import React, { useState } from "react";
import Tooltip from "rc-tooltip";
import "rc-tooltip/assets/bootstrap_white.css";
import FBCommonUtil from '../../../../Fireboard/common';
import classes from "./CheckDetails.module.css";
import constants from "../../../../../globalization";
import printIcon from "../../../../../assets/images/Fireboard/print.png";
import FireboardUtils from "../../../../../util/fireboard-util";

import FireboardTip from "./FireboardTip";
import CheckItems from "./CheckItems";
import classNames from "classnames";

const printOptions = [
  {
    id: 0,
    display: "INDIVIDUAL ITEM LABELS",
  },
  {
    id: 1,
    display: "ORDER + ITEMS LABELS",
  },
  {
    id: 2,
    display: "FULL ORDER LABEL",
  },
  {
    id: 3,
    display: 'KITCHEN TICKET',
  },
  {
    id: 4,
    display: 'GUEST RECEIPT',
  },
];

const CheckDetails = (props) => {
  const {
    selectedItem = {},
    items = [],
    supportsTipsOnTotalAmount = false,
    showMemberDetailPopup = () => { },
    onPrintPress = () => { },
    pendingItems = [],
    getManagerNotifications: relatedNotifications,
    acknowledgeIdCheck,
    showApprovalReasonsPopup,
    checkDetailsStyles = {},
    currency,
    iso2,
    suppressTipsOnFireBoard,
  } = props || {};

  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [selectedAction, setSelectedAction] = useState(-1);

  const isPOSOrder =
    FBCommonUtil.getOrderTypeFromSourceType(selectedItem.sourceType) ===
    constants.orderType_POS;

  const renderOverlayContent = () => {
    return (
      <div className={classes.overlayContainer}>
        {printOptions.map((p, printIndex) => {
          return (
            <button
              key={p.id}
              className={classNames({ [classes.printBtn]: true, [classes.highligthtedAction]: selectedAction === printIndex })}
              onClick={() => onPrintPress("check", p)}
              onMouseEnter={() => setSelectedAction(printIndex)}
              onMouseLeave={() => setSelectedAction(-1)}
            >
              <span className={classes.printBtnTextStyle}>{p.display}</span>
            </button>
          );
        })}
      </div>
    );
  };

  const getFormattedTime = field => {
    if (selectedItem.selectedCheckDetails && selectedItem.selectedCheckDetails[field]) {
      return FireboardUtils.getTimeInHrsMins(selectedItem.selectedCheckDetails[field]);
    }
    return '';
  };

  const getIsCurbOrder = () => {
    return selectedItem.sourceType === 5;;
  };

  const getOrderStatus = (item) => {
    const orderStatusId = item.orderStatusId;
    switch (orderStatusId) {
      case 1:
        return constants.orderPending;
      case 2:
        return constants.orderReady;
      case 5:
        return constants.orderComplete;
      case 8:
        return constants.cancelOrderText;
      case 9:
        return constants.orderError;
      default:
        return "";
    }
  };

  const pendingItemsToBeShown = isPOSOrder ? Object.keys(pendingItems) : pendingItems;

  const order0 = selectedItem.orders && selectedItem.orders.length > 0 && selectedItem.orders[0];

  return (
    <div className={[classes.checkDetails, checkDetailsStyles].join(' ')}>
      <div className={classes.topContainer}>
        <div className={classes.phoneNumber}>
          <span className={classes.phoneNumberText}>{`${constants.phnNumberText
            }${Object.keys(selectedItem).length > 0 && selectedItem.phoneNumber
              ? FireboardUtils.formattedPhoneNumber(selectedItem.phoneNumber, iso2)
              : ""
            }`}</span>
        </div>
        <div className={classes.checkIn}>
          <span className={classes.checkInText}>
            {`${constants.checkInNote}${Object.keys(selectedItem).length > 0 && selectedItem && selectedItem.selectedCheckDetails && selectedItem.selectedCheckDetails.checkInNote
                ? selectedItem.selectedCheckDetails.checkInNote
                : ""
              }`}
          </span>
        </div>
        <div className={classes.printImageContainer}>
          <Tooltip
            placement="bottomRight"
            visible={tooltipVisible}
            overlay={renderOverlayContent()}
            trigger={"click"}
            overlayInnerStyle={{ padding: "0.93vh", backgroundColor: "gray" }}
            onVisibleChange={(visible) => setTooltipVisible(visible)}
          >
            <button className={classes.printAllBtn}>
              <img src={printIcon} className={classes.iconSize} alt="print" />
            </button>
          </Tooltip>
        </div>
      </div>

      <div className={classes.topContainer}>
        <div className={classes.phoneNumber}>
          <span className={classes.toolTipHeaderText}>{constants.checkOpen}</span>
          <span className={classes.toolTipHeaderText}>{getFormattedTime('orderDate')}</span>
        </div>
        <div className={classes.phoneNumber}>
          <span className={classes.toolTipHeaderText}>{constants.checkClosed}</span>
          <span className={classes.toolTipHeaderText}>{getFormattedTime('completedDate')}</span>
        </div>
        <div className={classes.phoneNumber}>
          <span className={classes.toolTipHeaderText}>{constants.itemCount}:</span>
          <span className={classes.toolTipHeaderText}>{FBCommonUtil.getItemCount(selectedItem.items)}</span>
        </div>
        {getIsCurbOrder() && (
          <div className={classes.phoneNumber}>
            <span className={classes.toolTipHeaderText}>{constants.order}:</span>
            <span className={classes.toolTipHeaderText}>{getOrderStatus(selectedItem).toUpperCase()}</span>
          </div>
        )}
      </div>

      {order0 && order0.delivery && (
        <div className={classes.addressText}>
          <span className={classes.toolTipHeaderText}>{`${order0.address || ''}, ${order0.city || ''} ${order0.state || ''} ${order0.zipCode || ''}`}</span>
        </div>
      )}

      {pendingItemsToBeShown && pendingItemsToBeShown.length > 0 ? (
        <CheckItems
          posItemKeys={isPOSOrder && Object.keys(pendingItems).sort()}
          items={pendingItems}
          selectedItem={selectedItem}
          showMemberDetailPopup={showMemberDetailPopup}
          onPrintPress={onPrintPress}
          relatedNotifications={relatedNotifications}
          isPending={true}
          acknowledgeIdCheck={acknowledgeIdCheck}
          showApprovalReasonsPopup={showApprovalReasonsPopup}
          currency={currency}
        />
      ) : null}

      <CheckItems
        posItemKeys={isPOSOrder && Object.keys(items).sort()}
        items={items}
        selectedItem={selectedItem}
        showMemberDetailPopup={showMemberDetailPopup}
        onPrintPress={onPrintPress}
        relatedNotifications={relatedNotifications}
        acknowledgeIdCheck={acknowledgeIdCheck}
        showApprovalReasonsPopup={showApprovalReasonsPopup}
        currency={currency}
      />

      <FireboardTip
        selectedItem={selectedItem}
        supportsTipsOnTotalAmount={supportsTipsOnTotalAmount}
        currency={currency}
        suppressTipsOnFireBoard={suppressTipsOnFireBoard}
      />
    </div>
  );
};

export default CheckDetails;
